<div class="tw-grid md:tw-grid-cols-2 md:tw-h-[37rem]">
    <div class="tw-bg-black tw-rounded-br-[3rem] tw-py-6">
        <div class="tw-flex tw-justify-center tw-gap-2">
            <div (click)="elementClick(1)" [ngClass]="{'tw-border-b-2 tw-border-white': mobile === true}"
                class="tw-px-2 tw-text-white tw-font-bold">Mobile</div>
            <div (click)="elementClick(2)" [ngClass]="{'tw-border-b-2 tw-border-white': dashboard === true}"
                class="tw-px-2 tw-text-white tw-font-bold">Dashboard</div>
        </div>
        <div class="tw-flex tw-justify-center tw-h-[30rem]">
            <div class="tw-m-6 tw-w-52" *ngIf="mobile"><img class="tw-rounded tw-shadow"
                    src="/assets/images/corporate/Splash Screen.svg" alt="Mobile Screen" /></div>
            <div class="tw-m-6 tw-self-center" *ngIf="dashboard"><img class="tw-rounded tw-shadow"
                    src="/assets/images/corporate/dashboard.png" alt="Dashboard Screen" /></div>
        </div>
    </div>
    <div class="tw-p-6 md:tw-p-0 tw-m-4 md:tw-m-16">
        <div *ngIf="mobile">
            <div class="tw-font-extrabold tw-text-3xl tw-text-left ">Mobile Application</div>
            <p class="tw-text-xs tw-py-6">Complete end to end tech enabled</p>
            <div class="tw-text-left">
                <ul class="tw-text-sm tw-leading-[2rem] md:tw-leading-[3rem]">
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Single click for service, maintenance, emergency and
                            general queries</li>
                    </span>
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> 24x7 Roadside assistance connect</li>
                    </span>
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Digital vault for all key vehicle documents - RC, Insurance
                            and PUC</li>
                    </span>
                </ul>
            </div>
        </div>
        <div *ngIf="dashboard">
            <div class="tw-font-extrabold tw-text-3xl tw-text-left ">Dashboard</div>
            <p class="tw-text-xs tw-py-6">Making Car Lease Policy Administration Easier </p>
            <div class="tw-text-left">
                <ul class="tw-text-sm tw-leading-[2rem] md:tw-leading-[3rem]">
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Single window for all vehicles under your corporate lease
                        </li>
                    </span>
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Key metrics - Services SLA's and TAT's for each vehicle
                        </li>
                    </span>
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Approvals on quotations & agreements simplified</li>
                    </span>
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Success ratio of the corporate car subscription program
                        </li>
                    </span>
                    <span><fa-icon [icon]="faCheck"></fa-icon>
                        <li> Ease of lease management through corporate dashboard -
                            Accounts,Payments,TDS,GST,etc </li>
                    </span>
                </ul>
            </div>
        </div>
        <div class="tw-text-center md:tw-text-left tw-mt-16">
            <a type="button" href="contact-us"
                class="tw-rounded-md tw-bg-pinkDark tw-px-4 tw-py-2 tw-text-white  tw-text-xs md:tw-text-sm tw-font-bold hover:tw-text-white">
                Get in touch &nbsp;<fa-icon [icon]="faArrowRight"></fa-icon>
            </a>
        </div>
    </div>
</div>